import { render } from "./ListarCategorias.vue?vue&type=template&id=541c93ed&scoped=true"
import script from "./ListarCategorias.vue?vue&type=script&lang=js"
export * from "./ListarCategorias.vue?vue&type=script&lang=js"

import "./ListarCategorias.vue?vue&type=style&index=0&id=541c93ed&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-541c93ed"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QTable from 'quasar/src/components/table/QTable.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QBtn,QInput,QIcon,QCard,QCardSection,QPagination,QTooltip,QTabs,QTab,QTable});
